// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as Marked from "marked";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function FAQPage(Props) {
  const match = React.useState(function () {
    return /* [] */ 0;
  });
  const setIdxes = match[1];
  const idxes = match[0];
  const match$1 = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match$1[1];
  const faq = match$1[0].faqs;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.faq(undefined),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), []);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: "Вопрос-Ответ",
        className: "h4 lg:h3 text-black-landing mb-6 lg:mb-16"
      }),
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, d) {
        const Key = "faq_" + String(i);
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h6", {
                  children: d.question,
                  className: "h6 text-black-landing"
                }),
                Stdlib__List.exists((function (idx) {
                  return idx === i;
                }), idxes) ? JsxRuntime.jsx("img", {
                    className: "shrink-0 ml-4",
                    src: StaticAsset.src("/static/icons/minus.svg")
                  }) : JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/plus-black.svg")
                  })
              ],
              className: "flex justify-between py-4 border-b border-divider items-center cursor-pointer",
              onClick: (function (param) {
                if (Stdlib__List.exists((function (idx) {
                    return idx === i;
                  }), idxes)) {
                  return Curry._1(setIdxes, (function (state) {
                    return Stdlib__List.filter((function (item) {
                      return item !== i;
                    }), state);
                  }));
                } else {
                  return Curry._1(setIdxes, (function (state) {
                    return Stdlib__List.append(state, {
                      hd: i,
                      tl: /* [] */ 0
                    });
                  }));
                }
              })
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                className: "faq-answer",
                dangerouslySetInnerHTML: {
                  __html: Marked.marked(d.answer)
                }
              }),
              className: Cn.fromList({
                hd: "border-b border-divider py-6",
                tl: {
                  hd: Stdlib__List.exists((function (idx) {
                    return idx === i;
                  }), idxes) ? "block" : "hidden",
                  tl: /* [] */ 0
                }
              })
            })
          ]
        }, Key);
      }), faq))
    ],
    className: "flex m-auto flex-col py-10 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-252"
  });
}

const make = FAQPage;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
